import { useTranslation } from 'react-i18next';
import { PartyPopper } from 'lucide-react';
import { useThemeContext } from '@utils/providers/theme-context.tsx';
import type { Connection } from '@utils/types/connections/connection.ts';
import { getPlatformSpec } from '@utils/types/connections/platforms.ts';

interface Props {
  connection: Connection | null;
}

export default function StepDone({ connection }: Props) {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();
  const platformName = connection
    ? (getPlatformSpec(connection.platform)?.displayName ?? connection.platform)
    : '';

  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      <PartyPopper
        className="h-10 w-10"
        aria-hidden="true"
        style={{ color: getColour('activeText') }}
      />
      <p className="text-base font-semibold">
        {t('publishing-wizard-done-title', { platform: platformName })}
      </p>
      <p
        className="max-w-md text-sm"
        style={{ color: getColour('inactiveText') }}
      >
        {t('publishing-wizard-done-subtitle', {
          account: connection?.account_name ?? ''
        })}
      </p>
    </div>
  );
}
